export { SplitFactory } from './splitFactory';
export { InLocalStorage } from '@splitsoftware/splitio-commons/cjs/storages/inLocalStorage/index';
export { ErrorLogger } from '@splitsoftware/splitio-commons/cjs/logger/browser/ErrorLogger';
export { WarnLogger } from '@splitsoftware/splitio-commons/cjs/logger/browser/WarnLogger';
export { InfoLogger } from '@splitsoftware/splitio-commons/cjs/logger/browser/InfoLogger';
export { DebugLogger } from '@splitsoftware/splitio-commons/cjs/logger/browser/DebugLogger';
